var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "375pt",
    height: "374.999991pt",
    viewBox: "0 0 375 374.999991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 37.5 40 L 337.5 40 L 337.5 336 L 37.5 336 Z M 37.5 40 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(34.509277%,17.248535%,24.308777%)",
      fillOpacity: 1
    },
    d: "M 61.980469 375 L 313.019531 375 C 347.195312 375 375 347.195312 375 313.019531 L 375 61.980469 C 375 27.804688 347.195312 0 313.019531 0 L 61.980469 0 C 27.804688 0 0 27.804688 0 61.980469 L 0 313.019531 C 0 347.195312 27.804688 375 61.980469 375 Z M 61.980469 375 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 187.5 40 C 104.664062 40 37.5 107.164062 37.5 190 C 37.5 260.289062 85.898438 319.101562 151.148438 335.375 C 150.449219 333.351562 150 331 150 328.085938 L 150 302.449219 C 143.914062 302.449219 133.710938 302.449219 131.148438 302.449219 C 120.886719 302.449219 111.761719 298.039062 107.335938 289.835938 C 102.425781 280.726562 101.574219 266.789062 89.398438 258.261719 C 85.789062 255.425781 88.539062 252.1875 92.699219 252.625 C 100.386719 254.800781 106.761719 260.074219 112.761719 267.898438 C 118.738281 275.738281 121.550781 277.511719 132.710938 277.511719 C 138.125 277.511719 146.226562 277.199219 153.851562 276 C 157.949219 265.585938 165.039062 256 173.699219 251.476562 C 123.75 246.335938 99.914062 221.488281 99.914062 187.75 C 99.914062 173.226562 106.101562 159.175781 116.613281 147.335938 C 113.164062 135.585938 108.824219 111.625 117.9375 102.5 C 140.414062 102.5 154 117.074219 157.261719 121.011719 C 168.460938 117.175781 180.761719 115 193.6875 115 C 206.636719 115 218.988281 117.175781 230.210938 121.039062 C 233.4375 117.125 247.039062 102.5 269.5625 102.5 C 278.710938 111.636719 274.324219 135.699219 270.835938 147.425781 C 281.289062 159.238281 287.4375 173.25 287.4375 187.75 C 287.4375 221.460938 263.636719 246.300781 213.761719 251.460938 C 227.488281 258.625 237.5 278.75 237.5 293.914062 L 237.5 328.085938 C 237.5 329.386719 237.210938 330.324219 237.0625 331.4375 C 295.511719 310.949219 337.5 255.449219 337.5 190 C 337.5 107.164062 270.335938 40 187.5 40 Z M 187.5 40 "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.c007931e6721a12cec77270469e2907d.svg";
export { ForwardRef as ReactComponent };